<template>
    <div class="my-auto ml-n10">
        <v-btn icon @click="toRoutines">
            <v-icon color="secondary">mdi-fire</v-icon>
        </v-btn>
        <v-badge v-if="noRead" color="secondary" content="!" offset-x="20" offset-y="20"
                 bordered>
            <v-btn icon @click="toChat">
                <v-icon color="secondary">mdi-message-processing-outline</v-icon>
            </v-btn>
        </v-badge>
        <v-btn v-else icon @click="toChat">
            <v-icon color="secondary">mdi-message-processing-outline</v-icon>
        </v-btn>
        <chat-dialog :clientId="studentId" ref="chat"></chat-dialog>
    </div>
</template>

<script>

import ChatDialog from '@/components/student/ChatDialog'
import {db} from "@/utils/Firebase";

export default {
    components:{
        ChatDialog,
    },
    data() {
        return {
            noRead: false,
        }
    },
    computed: {
        studentId(vm = this) {
            return vm.$route.params.uid || null
        }
    },
    async mounted() {
        const vm = this
        await vm.checkLastMessage()
    },
    methods: {
        toRoutines(){
            var vm = this
            vm.$router.push({name: 'coach.calendar', query: {studentId: vm.studentId}})
        },
        toChat(){
            var vm = this
            vm.$refs.chat.show()
        },
        async checkLastMessage() {
            const vm = this
            let coachId = vm.currentUser.uid
            let userId = vm.studentId
            if (!coachId || !userId) return
            let chatRef = await db.collection('privateChats')
            chatRef.where('type', '==', 'coach_student')
            chatRef.where('participants', 'in', [[coachId, userId]])
                .get().then(async chat => {
                if (chat.docs.length > 0) {
                    let lastMessage = chat.docs[0].data().lastMessage || null
                    if (lastMessage && lastMessage.from && lastMessage.from === coachId) {
                        vm.noRead = false
                    } else {
                        vm.noRead = lastMessage && !lastMessage.read
                    }
                }
            })
        },
    },
    watch: {
        account(val) {
            this.checkLastMessage()
        }
    }
}
</script>